// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileDeclineProposalModal_modal_body__5_B0K","footer":"MobileDeclineProposalModal_footer__2YbqD"};